export default "__VITE_ASSET__e36ee667__"